import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import UserSummaryService from '../../services/UserSummaryService';
import {ColumnGroup} from 'primereact/columngroup';
import {Row} from 'primereact/row';
import {Column} from 'primereact/column';
import ActionButton from '../../components/ActionButton';
import StringUtils from '../../utils/StringUtils';
import CurrencyUtils from '../../utils/CurrencyUtils';
import InternalUserService from '../../services/MobileUserService';
import CriteriaCalendarComponent from '../../components/criteria/CriteriaCalendarComponent';
import PayrollRequestDialog from './PayrollRequestDialog';
import ActionLink from '../../components/ActionLink';
import DivContainer from '../../components/DivContainer';
import BaseBreadCrumb from '../../baseContainers/BaseBreadCrumb';
import CompanyAgreementBanner from '../../components/CompanyAgreementBanner';
import {Card} from 'react-bootstrap';
import {CustomMessages} from '../../components/CustomMessages';
import BlockUi from '../../components/waitPanel/BlockUi';
import UserTransportDetailsDialog from './UserTransportDetailsDialog';
import YesNoDialog from '../../components/YesNoDialog';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';

class UserTransportListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new UserSummaryService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            showDetailDialog: false,
            detailRowData: undefined,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            showConfirmRemoveDialog: false,
            payrollDialogVisibile: false,
            selectedList: [],
            unselectedList: [],
        };
        this.mobileUserService = new InternalUserService();
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            date: criteria.date,
            email: criteria.email,
            transportName: criteria.transportName,
            headers: criteria.headers,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            email: '',
            transportName: '',
            date: new Date(),
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {}

    afterRowSelected(e) {
        console.log(e.type);
    }

    getDataKey() {
        return 'email';
    }
    getListTitle() {
        return 'user-summary.listTitle';
    }
    getCriteriaName() {
        return 'user-summary-list-sc';
    }

    getContainerListName() {
        return 'user-summary-list-container';
    }
    moneyTemplate(rowData) {
        return CurrencyUtils.currency(rowData.money);
    }
    avatarTemplate = (rowData) => {
        const fileUuid = rowData?.avatar?.fileUuid;
        const avatarPath = this.mobileUserService.getPath() + `/${fileUuid}/avatar/current-user`;
        const img = StringUtils.isBlank(fileUuid) ? (
            ''
        ) : (
            <img
                src={`${avatarPath}?token=${this.authService.getToken()}`}
                // src={`https://source.unsplash.com/random/800x600`}
                alt='Avatar'
                className='product-image'
                style={{borderRadius: '50%', height: '30px', width: '30px', marginBottom: '-10px', marginTop: '-10px'}}
            />
        );
        return img;
    };
    prepareColumns() {
        return [
            {field: 'transportName', header: t('user-summary-list.transport')},
            {field: 'email', header: t('user.email')},
            {field: 'avatar', header: t('user-summary-list.avatar'), body: this.avatarTemplate},
            {field: 'fullName', header: t('user-summary-list.user')},
            {
                field: 'burnedCalories',
                header: t('user-summary-list.burned'),
                float: 'right',
            },
            {
                field: 'savedCo2Gram',
                header: (
                    <div>
                        {t('user-summary-list.saved')} CO<sub>2</sub>(g)
                    </div>
                ),
                float: 'right',
            },
            {
                field: 'workDistance',
                header: t('user-summary-list.declared'),
                float: 'right',
            },
            {field: 'totalDistanceTraveledInKilometers', header: t('user-summary-list.traveled'), float: 'right'},
            {field: 'money', header: t('user-summary-list.to_payout'), float: 'right', body: this.moneyTemplate},
            {field: '', header: 
                t('global.action'), float: 'center', body: this.actionTemplate},
        ];
    }

    actionTemplate(rowData) {
        const menuRef = React.createRef();
    
        const menuItems = [
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => {
                    this.setState({
                        showDetailDialog: true,
                        detailRowData: structuredClone(rowData),
                    });
                },
            }
        ];
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }

    actionTemplate2(rowData) {
        return (
            <div>
                <ActionLink
                    rendered={true}
                    className='p-link float-right'
                    handleClick={() => {
                        this.setState({
                            showDetailDialog: true,
                            detailRowData: structuredClone(rowData),
                        });
                    }}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='right'
                    iconSize='mdi-24px'
                    iconColor='blue'
                />
            </div>
        );
    }
    tableHeader() {
        return (
            <div className='flex flex-wrap justify-content-end gap-2'>
                <ActionButton
                    label={t('user-summary-list.prepare-payout')}
                    disabled={!(this.state.selectAllMode || (!this.state.selectAllMode && this.state.selectedList.length > 0))}
                    handleClick={() => {
                        this.setState({payrollDialogVisibile: true});
                        const selectAllMode = this.state.selectAllMode;
                        let reportIdList = [];
                        if (selectAllMode) {
                            reportIdList = this.state.unselectedList.map((e) => e.id);
                        } else {
                            reportIdList = this.state.selectedList.map((e) => e.id);
                        }
                        console.log(selectAllMode, reportIdList);
                    }}
                />
                <span style={{width: '20px'}}> </span>
                <ActionButton
                    reverse
                    label={t('user-summary-list.export')}
                    handleClick={() => {
                        this.service.export(this.state.criteria, t('user-summary-list.listName'), 'xlsx').catch(() => {
                            this.showErrorMessage(t('global.gegerate-error'));
                        });
                    }}
                />
            </div>
        );
    }

    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaTextComponent
                        id='email-sc'
                        name='email'
                        label={t('user.email')}
                        colClass='col-lg-3 col-sm-6'
                        value={this.state.criteria.email}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />

                    <CriteriaTextComponent
                        id='transport-name-sc'
                        name='transportName'
                        label={t('user-summary-list.transport')}
                        colClass='col-lg-3 col-sm-6'
                        value={this.state.criteria.transportName}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaCalendarComponent
                        label={(t('global.month'))}
                        id='dateSc'
                        name='date'
                        showIcon
                        colClass='col-lg-3'
                        viewMode='EDIT'
                        value={this.state.criteria.date}
                        onChange={(a, b, e, d, f, g, h) => {
                            if (e.value === null) {
                                e.value = '';
                                e.target.value = '';
                            }
                            this.handleChangeSc(a, b, e, d, f, g, h);
                        }}
                        view='month'
                        placeholder='mm-yy'
                        dateFormat='mm-yy'
                        validator={this.validator}
                    />
                </div>
            </div>
        );
    }

    prepareHeaderItems() {
        return [];
    }

    footerGroup() {
        const {summary} = this.state;
        return (
            <ColumnGroup>
                <Row>
                    <Column footer={t('list.summary')} />
                    <Column footer='' colSpan={4} />
                    <Column footer={summary.summedBurnedCalories} footerStyle={{textAlign: 'right'}} />
                    <Column footer={summary.summedSavedCo2Gram} footerStyle={{textAlign: 'right'}} />
                    <Column footer={summary.summedWorkDistance} footerStyle={{textAlign: 'right'}} />
                    <Column footer={summary.summedTotalDistanceTraveledInKilometers} footerStyle={{textAlign: 'right'}} />
                    <Column footer={CurrencyUtils.currency(summary.summedMoney)} footerStyle={{textAlign: 'right'}} />
                    <Column footerStyle={{textAlign: 'right'}} />
                </Row>
            </ColumnGroup>
        );
    }
    renderView() {
        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <CompanyAgreementBanner />
                    <BaseBreadCrumb items={this.breadCrumbItems()} />
                    <Card className={'list-card'}>
                        <DivContainer colClass='row'>{this.renderFilter()}</DivContainer>
                        <DivContainer colClass='row'>{this.renderHeader()}</DivContainer>

                        {this.renderDataTable(this.prepareColumns())}
                        {this.state.renderDialog === true && this.renderDialog()}
                    </Card>
                </BlockUi>
                {this.state.showDetailDialog && (
                    <UserTransportDetailsDialog
                        blockUi={this.blockUi}
                        date={this.state.criteria.date}
                        unblockUi={this.unblockUi}
                        onHide={() => {
                            this.setState({
                                showDetailDialog: false,
                            });
                        }}
                        visible={this.state.showDetailDialog}
                        element={this.state.detailRowData}
                    />
                )}
            </DivContainer>
        );
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return null;
    }

    breadCrumbItems() {
        return [{name: t('user-summary-list.listName'), url: '/user-summary-list'}];
    }
    handleClosePayrollRequestDialog(e, callback) {
        if (e) {
            e.preventDefault();
        }
        this.setState({payrollDialogVisibile: false});
        if (callback) callback();
    }

    render() {
        return (
            <div className='container-fluid'>
                {this.state.payrollDialogVisibile ? (
                    <PayrollRequestDialog
                        style={{maxWidth: '500px'}}
                        roleOptions={this.state.roleUser}
                        selectAll={this.state.selectAllMode}
                        users={
                            this.state.selectAllMode ? this.state.unselectedList.map((e) => e.id) : this.state.selectedList.map((e) => e.id)
                        }
                        onHide={(e) => this.handleClosePayrollRequestDialog(e)}
                        visible={this.state.payrollDialogVisibile}
                        viewMode='NEW'
                        afterSave={(e) =>
                            this.handleClosePayrollRequestDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                                this.unblockUi();
                            })
                        }
                        handleError={(err) => {
                            this.handleClosePayrollRequestDialog(null, () => {
                                this.unblockUi();
                                console.log(err);
                                this.showErrorMessage(err.json.message);
                            });
                        }}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                        showErrorMessage={this.showErrorMessage}
                        showSuccessMessage={this.showSuccessMessage}
                    />
                ) : null}

                {this.renderView()}
            </div>
        );
    }
}

UserTransportListContainer.defaultProps = {
    lazy: true,
    disablePointerFromList: true,
    selectionMode: 'multiple',
};

UserTransportListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    disablePointerFromList: PropTypes.string,
};

export default withRouter(withTranslation()(UserTransportListContainer));
